import { jsx as _jsx } from "react/jsx-runtime";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var MaybeFaireDirectBrandBannerImage = function() {
    var faireDirectBrand = useFaireDirectBrand().faireDirectBrand;
    var _faireDirectBrand_banner_image;
    var bannerImage = optimizeImageUrl((_faireDirectBrand_banner_image = faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.banner_image) !== null && _faireDirectBrand_banner_image !== void 0 ? _faireDirectBrand_banner_image : {}, false, {
        height: 120
    });
    if (!bannerImage) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ImageContainer, {
        children: /*#__PURE__*/ _jsx("img", {
            src: bannerImage,
            alt: ""
        })
    });
};
var ImageContainer = styled.div.withConfig({
    componentId: "sc-b5a029da-0"
})([
    "width:100%;height:120px;",
    "{height:100%;}img{width:100%;height:100%;object-fit:cover;}"
], responsiveMediaQueries.mobile);
